export const handleAuthenticationErrorMessage = (err, intl) => {
  const { error, code } = err || {};
  const errorType = error || code;

  switch (errorType) {
    case "unauthorized":
    case "invalid username/password":
      // Invalid email address or password
      return intl.formatMessage({ id: "error-messages-unauthorized" });
    case "confirm email":
      // Email is already registered
      return intl.formatMessage({ id: "error-messages-confirm-email" });
    case "name already in use":
      // Email is already registered
      return intl.formatMessage({ id: "error-messages-name-already-in-use" });
    case "auth/too-many-requests":
      return intl.formatMessage({ id: "error-messages-too-many-requests" });
    case "password must be between 6 and 128 characters":
      // Invalid password - must be between 6 and 128 characters
      return intl.formatMessage({ id: "error-messages-password-must-be-between-6-and-128-characters" });
    case "user not found":
      // Invalid password - must be between 6 and 128 characters
      return intl.formatMessage({ id: "error-messages-user-not-found" });
    default:
      // In theory you won't ever hit this default, but if an error message/code without a case ever comes up it will fall back to this.
      return `${intl.formatMessage({ id: "error-messages-default" })}${!!error ? `:\n${error}` : ""}`;
  }
};

export default handleAuthenticationErrorMessage;
